import "core-js/modules/es.array.fill.js";
export var radioPortalTokens = {
  colors: {
    base: function base(_ref) {
      var color = _ref.color;
      return color.border.input.base;
    },
    baseHover: function baseHover(_ref2) {
      var color = _ref2.color;
      return color.border.input.hover;
    },
    baseDisabled: function baseDisabled(_ref3) {
      var color = _ref3.color;
      return color.border.input.base;
    },
    checked: function checked(_ref4) {
      var color = _ref4.color;
      return color.importance.primary.base;
    },
    checkedHover: function checkedHover(_ref5) {
      var color = _ref5.color;
      return color.importance.primary.hover;
    },
    checkedDisabled: function checkedDisabled(_ref6) {
      var color = _ref6.color;
      return color.importance.primary.base;
    },
    invalidBase: function invalidBase(_ref7) {
      var color = _ref7.color;
      return color.border.input.invalid.base;
    },
    invalidHover: function invalidHover(_ref8) {
      var color = _ref8.color;
      return color.border.input.invalid.hover;
    },
    focusBase: function focusBase(_ref9) {
      var color = _ref9.color;
      return color.border.focus.base;
    },
    focusHover: function focusHover(_ref10) {
      var color = _ref10.color;
      return color.border.focus.hover;
    },
    focusInvalid: function focusInvalid(_ref11) {
      var color = _ref11.color;
      return color.border.focus.invalid.base;
    },
    focusInvalidHover: function focusInvalidHover(_ref12) {
      var color = _ref12.color;
      return color.border.focus.invalid.hover;
    },
    text: function text(_ref13) {
      var color = _ref13.color;
      return color.text.black.base;
    },
    textDisabled: function textDisabled(_ref14) {
      var color = _ref14.color;
      return color.text.black.base;
    },
    fill: function fill(_ref15) {
      var color = _ref15.color;
      return color.fill.item.base;
    },
    fillDisabled: function fillDisabled(_ref16) {
      var color = _ref16.color;
      return color.fill.item.base;
    },
    opacityOnDisable: 0.5
  },
  wrapperPaddingY: {
    s: 7,
    m: 9,
    l: 11
  },
  circle: {
    borderWidth: 2,
    checkedBorderWidth: {
      s: 4,
      m: 6,
      l: 7
    },
    focusBoxShadowAttrs: "0 0 3px 1px",
    radius: {
      s: 16,
      m: 22,
      l: 26
    }
  },
  label: {
    marginLeft: {
      s: 6,
      m: 6,
      l: 8
    }
  }
};